import { Component, inject, OnInit, resource } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, map } from 'rxjs';
import { CodesService } from '../../services/codes/codes.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-handle-code',
  imports: [CommonModule],
  templateUrl: './handle-code.component.html',
  styleUrl: './handle-code.component.css'
})
export class HandleCodeComponent implements OnInit {
  

  private readonly $route = inject(ActivatedRoute);
  private readonly $router = inject(Router) ;
  private readonly $codes = inject(CodesService);

  failed: boolean = false ;

  async ngOnInit() {
    const code = this.$route.snapshot.params['code'] ;

    try {
      const result = await firstValueFrom(this.$codes.get(code)) ;
      console.log("Result: ", result) ;

      if (result.type == 'COURSE_INVITE') {
        this.$router.navigate(['student', 'courses', result.courseId!, 'join']) ;
      } else if (result.type == 'CHECKIN') {
        this.$router.navigate(['student', 'courses', result.courseId!, 'checkins', result.checkinId!]) ;
      } else {
        console.error("Unknown code type: ", result) ;
        this.failed = true ;
      }

    } catch (e) {
      console.error("Error handling code: ", e) ;
      this.failed = true ;
    }

}

}
